package com.steamstreet.vegasful.browser.account

import com.steamstreet.vegasful.css.VegasfulStyles
import com.steamstreet.vegasful.css.css
import com.steamstreet.vegasful.web.analytics.Analytics
import com.steamstreet.vegasful.web.analytics.AnalyticsEvent
import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import kotlinx.css.*
import kotlinx.html.TagConsumer
import kotlinx.html.button
import kotlinx.html.js.onClickFunction
import kotlinx.html.p

private val deleteClient = HttpClient(JsClient())

/**
 * Show the account delete option.
 *
 * The request goes to `/auth/delete`, as the app's does, which marks the account for deletion and
 * signs it out everywhere. The account is deleted when the grace period ends; see
 * `specs/account-deletion.md`.
 */
fun <T> TagConsumer<T>.accountDelete(context: CoroutineScope) {
    accountDialog("Delete Account") {
        p {
            +("Submit here to request that your account be deleted and all data associated with your account be deleted.")
        }
        p {
            +("Your account is disabled straight away and deleted after seven days. If you change your mind " +
                    "within that time, email us at vegasful@steamstreet.com and we will try to stop the deletion.")
        }

        button {
            css {
                width = 100.pct
                display = Display.flex
                fontSize = 18.px
                fontWeight = FontWeight.w600
                padding = Padding(8.px)
                borderRadius = 5.px
                marginTop = 8.px
                cursor = Cursor.pointer
                +VegasfulStyles.largeButton
            }
            onClickFunction = {
                context.launch {
                    try {
                        // Absolute, as everywhere else the client calls back: a bare path leaves
                        // the Ktor URL builder on its default host rather than the page's own. The
                        // same-origin request carries the auth cookie, which is what signs it.
                        val response = deleteClient.post("${window.location.origin}/auth/delete")
                        if (!response.status.isSuccess()) {
                            throw IllegalStateException("Deletion request failed: ${response.status}")
                        }
                        // Reported before the sign-out that follows, so the two appear in the
                        // order they happened. A deletion is also the point at which the
                        // analytics side of `docs/analytics-plan.md` §2.5 will need to purge
                        // what GA4 holds for this user; nothing does that yet.
                        Analytics.track(AnalyticsEvent.ACCOUNT_DELETED)
                        window.alert(
                            "Your account is scheduled for deletion and will be deleted in seven days. " +
                                    "You will be logged out now."
                        )
                        Account.logout()
                    } catch (t: Throwable) {
                        window.alert(
                            "We weren't able to request the deletion. Please try again, or email us at " +
                                    "vegasful@steamstreet.com."
                        )
                    }
                }
            }
            +"Delete Account"
        }
    }
}